function jsonStringifyMap(mapObj) {
    return JSON.stringify(Array.from(mapObj.entries()))
}
function jsonParseMap(jsonMapText) {
    return new Map(JSON.parse(jsonMapText))
}

export default {
    jsonStringifyMap,
    jsonParseMap,
}